import { FC, useCallback, useState } from "react";

import { IProductionChainPreviewStep } from "@ryde/shared";

import { Collapse } from "../../collapse";
import { ProductionChainStepContent } from "../components";
import { ProductionChainStepWrapper } from "./production-chain-step-preview.styled";

interface IProductionChainStepPreviewProps {
  chainStep: IProductionChainPreviewStep;
}

export const ProductionChainStepPreview: FC<
  IProductionChainStepPreviewProps
> = ({ chainStep }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleToggleCollapsed = useCallback(() => {
    setIsCollapsed(prev => !prev);
  }, []);

  const collapseHeader = (
    <span className="collapse-header__title">{chainStep.chainName}</span>
  );

  return (
    <ProductionChainStepWrapper>
      <Collapse
        CollapseHeader={collapseHeader}
        isInner
        isCollapsed={isCollapsed}
        onToggleCollapsed={handleToggleCollapsed}
      >
        <div className="production-chain-step-inner">
          <ProductionChainStepContent chainStep={chainStep} />
        </div>
      </Collapse>
    </ProductionChainStepWrapper>
  );
};
